export class RefreshTokenModel {
	public accessToken: string;
	public azureToken: string;
	public refreshToken: string;

	public convert(dto: any): RefreshTokenModel {
		if (dto.accessToken) {
			this.accessToken = dto.accessToken;
		}
		if (dto.azureToken) {
			this.azureToken = dto.azureToken;
		}
		if (dto.refreshToken) {
			this.refreshToken = dto.refreshToken;
		}

		return this;
	}

	public storeRefreshTokenToLocalStorage(data: RefreshTokenModel) {
		localStorage.setItem('EMRAdmin.accessToken', data.accessToken);
		localStorage.setItem('EMRAdmin.azureToken', data.azureToken);
		localStorage.setItem('EMRAdmin.refreshToken', data.refreshToken);
	}
}
